import { makeAutoObservable } from 'mobx'
import { axiosInstance } from '../hooks/useAxios'
import { refreshToken } from '../api/refreshToken'
import { login } from '../api/login'
import { toast } from 'react-toastify'
import { logout } from '../api/logout'
import { UserStore } from './userStore'
import { NotificationsStore } from './notificationsStore'
import { ConfigStore } from './configStore'

class _AuthStore {
  isUserAuthenticated: boolean = false
  isPending: boolean = false

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  SET_USER_AUTHENTICATED = (isUserAuthenticated: boolean): void => {
    this.isUserAuthenticated = isUserAuthenticated
  }

  SET_PENDING = (isPending: boolean): void => {
    this.isPending = isPending
  }

  async login(email: string, password: string): Promise<any> {
    this.isPending = true

    try {
      const res = await axiosInstance(login(email, password))

      localStorage.setItem('token', res.data.data)
      UserStore.updateUserData()
      this.isUserAuthenticated = true
      await ConfigStore.getConfig('private')
      toast.success('Вы успешно авторизовались')
    } catch (e) {
      console.error(e)
      this.isUserAuthenticated = false

      return e
    } finally {
      this.isPending = false
    }
  }

  async logout(): Promise<any> {
    try {
      await axiosInstance(logout())
      localStorage.removeItem('token')
      this.isUserAuthenticated = false
      toast.success('Вы успешно вышли из аккаунта')
      UserStore.clearUserData()
    } catch (e: any) {
      console.error(e)

      toast.error(e.message)
      return e
    }
  }

  async checkAuth(): Promise<void> {
    this.isPending = true

    try {
      const res = await axiosInstance(refreshToken())

      localStorage.setItem('token', res.data.data)
      UserStore.updateUserData()
      this.isUserAuthenticated = true
    } catch (e) {
      console.error(e)

      if (localStorage.getItem('token')) {
        toast.error('Сессия истекла. Пожалуйста, авторизуйтесь')
        localStorage.removeItem('token')
      }

      this.isUserAuthenticated = false
    } finally {
      this.isPending = false
    }
  }
}

const AuthStore = new _AuthStore()

export { AuthStore }
